// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"241":"7ae249759962802f4550","259":"4ece0761ab76e2dda7fb","825":"b5d05839874abffb32c8"}[chunkId] + ".js";
};